import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  BackendResponse,
  DocumentReferenceEntityType,
  entityName,
  ItemDocumentReference,
} from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { DocumentReferenceService } from '../core/document-reference.service';

@Injectable({ providedIn: 'root' })
export class ItemDocumentReferenceService extends DocumentReferenceService<ItemDocumentReference> {
  protected http = inject(HttpClient);
  protected entityName: entityName = 'ItemDocumentReference';
  readonly entityType = DocumentReferenceEntityType.ITEM;

  /**
   * `DELETE /api/v2/model/ItemDocumentReference/bulk` — the data-room mixed
   * bulk-delete (documents split out from folders, see `FolderService.bulkDelete`).
   */
  bulkDelete(
    ids: readonly string[]
  ): Observable<BackendResponse<ItemDocumentReference[]>> {
    return this.http.delete<BackendResponse<ItemDocumentReference[]>>(
      `${this.baseURL}/bulk`,
      { ...this.baseRequestOptions, body: ids }
    );
  }
}
